import classNames from 'classnames';

const BANNER_MIN_HEIGHT = 56;

interface BannerProps {
  children: React.ReactNode | string;
  className?: string;
}

export function Banner(props: BannerProps) {
  const { children, className } = props;

  return (
    <div
      className={classNames(
        `flex items-center justify-center min-h-[${BANNER_MIN_HEIGHT}px] py-[12px] box-border w-full ${className}`
      )}
    >
      {children}
    </div>
  );
}
